import { types } from "mobx-state-tree"
import validate from 'validate.js'

const Dirty = types.model({
    name: types.optional(types.boolean, false),
    recipientEmail: types.optional(types.boolean, false),
})
const CustomerUIStore = types.model({
    recipientEmail: types.optional(types.string, ''),
    dirty: types.optional(Dirty, Dirty.create()),
    archiveDialogOpen: types.optional(types.boolean, false)
})
.actions(self=>({
    setRecipientEmail: (value)=>{
        self.dirty.recipientEmail = true
        self.recipientEmail = value;
    },
    clearRecipientEmail: (value)=>{
        self.dirty.recipientEmail = false
        self.recipientEmail = '';
    },
    setDirty: (key)=>{
        self.dirty[key] = true;
    },
    openArchiveDialog: () => {
        self.archiveDialogOpen = true;
    },
    closeArchiveDialog: () => {
        self.archiveDialogOpen = false;
    }
}))
.views(self=>({
    get errors(){
        var constraints = {
            recipientEmail: {
              presence: {message: 'Recipient email missing', allowEmpty: false},
              email: {message: 'Invalid email address'},              
            }
          };
          return validate(self, constraints, {fullMessages: false})
    },
}))

export default CustomerUIStore.create({})


// WEBPACK FOOTER //
// ./src/stores/CustomerUIStore.js